<template>

    <div class="container-md container-app p-0 ">
      <div class="wrapper">
        <div class="header"><h1>{{$t("layout_notifiche")}}</h1></div>
        <div class="content content-full">
          <div class="title">{{$t("layout_notifiche")}}</div>
          <hr>
          <div class="container">
            <div class="row-sezione">
            <div v-if="loading" class="text-center py-4">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
              <div v-else-if="!this.notifiche.length" class="text-center f14" style="margin-top: 30px;">
                {{$t('nessuna')}}
              </div>
              <div v-else>
                <div class="blocchetto d-flex justify-content-start rounded-lg"
                     v-for="(notifica, i) in notifiche"
                     :key="i"
                     :style="getNotificationStyle(notifica)"
                     @click="handleNotificationClick(notifica)">
                  <span class="material-symbols-outlined f40 mr-3">{{ getNotificationIcon(notifica) }}</span>
                  <div class="flex-grow-1">
                    <p class="mb-1">{{ notifica.testo }}</p>
                    <div class="f13" v-if="getNotificationSubtitle(notifica)">
                      {{ getNotificationSubtitle(notifica) }}
                    </div>
                    <b v-if="notifica.created_at">
                      {{ moment(notifica.created_at).locale(language).format('DD/MM/YYYY') }}
                    </b>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="container d-none d-md-block">
            <hr>
            <div class="row-sezione d-flex justify-content-center">
              <router-link :to="{name:'user'}">
                <button type="button" class="btn btn-default">{{$t('btn_indietro')}}</button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <modal-feedback
          v-if="show_feedback_modal"
          @close="show_feedback_modal = false"
          type="ORDINE"
          :item="selected_feedback_order"
      />
    </div>


</template>
<script>
import {mapState, mapActions} from 'vuex';
import {getNotificheInviate} from "../api/account";
import ModalFeedback from "./orders/partials/ModalFeedback.vue";

export default {
  name: "Notifiche",
  components: {ModalFeedback},
  data() {
    return {
      notifiche: [],
      loading: false,
      show_feedback_modal: false,
      selected_feedback_order: null
    }
  },
  created() {
    this.fetch();
  },
  computed: {
    ...mapState('localization', {
      language: state => state.language
    }),
    ...mapState('restaurant', {
      id_ristorante: state => state.id,
      locale: state => state.locale
    }),
    ...mapState('auth', {
      user: state => state
    })
  },
  watch: {
    language: function () {
      this.fetch();
    },
    id_ristorante: function () {
      this.fetch();
    },
    'locale.id': function () {
      this.fetch();
    }
  },
  methods: {
    fetch: function () {
      if (!this.user.api_key) {
        this.notifiche = [];
        this.loading = false;
        this.showLoading(false);
        return;
      }
      if (!this.id_ristorante) {
        return;
      }
      this.loading = true;
      this.showLoading(true);
      getNotificheInviate(this.language, {
        id_ristorante: this.id_ristorante,
        id_locale: this.locale ? this.locale.id : null,
        api_key: this.user.api_key
      }).then((response) => {
        this.notifiche = response.notifiche || [];
      }).catch(({messages}) => {
        alert(messages.join('\n'));
      }).finally(() => {
        this.loading = false;
        this.showLoading(false);
      });
    },
    getNotificationIcon: function (notifica) {
      switch (notifica.tipo) {
        case "FEEDBACK_ORDINE":
          return "hotel_class";
        case "FIDELITY_CARD_PUNTI":
        case "FIDELITY_CARD_SCADENZA":
          return "loyalty";
        case "PREMIO_ORDINI_EFFETTUATI":
          return "redeem";
        case "REGISTRAZIONE":
          return "celebration";
        case "ULTIMO_ORDINE":
        case "ORDINE_IN_CORSO":
          return "receipt_long";
        default:
          return "notifications";
      }
    },
    getNotificationStyle: function (notifica) {
      if (notifica.tipo === "FEEDBACK_ORDINE" && notifica.id_associazione) {
        return {cursor: 'pointer'};
      }
      return {cursor: 'default'};
    },
    handleNotificationClick: function (notifica) {
      if (notifica.tipo === "FEEDBACK_ORDINE" && notifica.id_associazione) {
        this.selected_feedback_order = {id: notifica.id_associazione};
        this.show_feedback_modal = true;
      }
    },
    getNotificationSubtitle: function (notifica) {
      if (!notifica.locali_codice_sconto) {
        return null;
      }
      if (notifica.locali_codice_sconto === true) {
        return this.$t('notifiche_valido_tutti_locali');
      }
      if (Array.isArray(notifica.locali_codice_sconto)) {
        return this.$t('notifiche_valido_locali') + ' ' + notifica.locali_codice_sconto.join(' - ');
      }
      return null;
    },
    ...mapActions('global', [
      'showLoading'
    ])
  }
}
</script>
